import { Type, Static } from "@sinclair/typebox";

export const ActionButtonNames = Type.Union([
  Type.Literal("view"),
  Type.Literal("createActivityTaskCase"),
  Type.Literal("createLeadContact"),
  Type.Literal("call"),
  Type.Literal("meeting"),
  Type.Literal("messenger"),
  Type.Literal("email"),
  Type.Literal("navigate"),
  Type.Literal("refresh"),
  Type.Literal("facebook"),
  Type.Literal("linkedin"),
  Type.Literal("google"),
  Type.Literal("find"),
  Type.Literal("addToPhone"),
  Type.Literal("createCustomObject"),
  Type.Literal("createCase"),
  Type.Literal("createTask"),
  Type.Literal("createActivity"),
  Type.Literal("createLead"),
  Type.Literal("createContact"),
  Type.Literal("createPersonAccount"),
  Type.Literal("chatNow"),
  Type.Literal("showChatSummarizeAction"),
  Type.Literal("createBusinessAccount"),
  Type.Literal("copyChat"),
  Type.Literal("showAiChat"),
]);

export type ActionButtonNamesType = Static<typeof ActionButtonNames>;
